/**
 * カート
 */
import Vue from 'vue'
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.FRONTEND_ENDPOINT}/carts/duplications`

const frontCartDuplication = {
  namespaced: true,
  state: {},
  getters: {
  },
  actions: {
    checkDuplications({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$http.get(API_PATH).then(data => {
          let content = data.content
          resolve(content)
        }).catch((error) => {
          console.log(error)
          reject()
        })
      })
    },
  },
  mutations: {
  },
}

export default frontCartDuplication
